<div>
  <p>
    Redirecting to landing page <br />
    Click <a [href]="landingUrl || '../'">here</a> if you don't get redirected
  </p>
</div>
